var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.theme.dropdownRaw
  }, _vm._l((_vm.items), function(item, index) {
    return _c('div', {
      key: index,
      class: _vm.getItemClasses(item),
      on: {
        "click": function($event) {
          _vm.$emit('select', item)
        }
      }
    }, [_vm._t("item", [_vm._v("\n            " + _vm._s(item) + "\n        ")], {
      item: item
    })], 2)
  }))
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-723e223b","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/baseComponents/components/Dropdown/DropdownRaw.vue
// module id = 518
// module chunks = 0